import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { Crumb } from '@interfaces';
import { LocalizationService } from '@core/services';

@Component({
  selector: 'info-drag-table-info',
  templateUrl: './info-drag-table-info.component.html',
  styleUrls: ['./info-drag-table-info.component.sass']
})
export class InfoDragTableInfoComponent implements OnChanges {
  @Input() info: any;
  public filteredInfo: any[] = [];
  public spacer = '<br/>';

  @Output() onEventClearSearchState: EventEmitter<any> = new EventEmitter();
  @Output() onEventLinkATHToSearch: EventEmitter<any> = new EventEmitter();

  constructor(private readonly localize: LocalizationService) {
  }

  ngOnChanges() {
      this.filteredInfo = (Object.entries(this.info))
        .map(([key, value]) => ({ key, value }))
        .filter(this.infoDragTableRowFilter);
  }

  public startPositionForTableRender(): number {
    return 0;
  }

  public eventClearSearchState(): void {
    this.onEventClearSearchState.emit();
  }

  public eventLinkATHToSearch(item): void {
    this.onEventLinkATHToSearch.emit(item);
  }

  public toLinkHrefCustomCatalog(crumb: Crumb): string {
    if (crumb.info === 'trade') {
      return this.localize.getRouterLinkApp('list') + '/' + crumb.url;
    }
    if (crumb.info === '3') {
      return this.localize.getRouterLinkApp('category') + '/' + crumb.url;
    }
    return this.localize.getRouterLinkApp('catalog') + '/' + crumb.url;
  }

  public infoDragTableRowFilter = (item) => {
    return item?.key !== 'permissions' &&
      item?.key !== 'priceRange' &&
      item?.key !== 'blisterNum' &&
      item?.key !== 'packageNum' &&
      item?.key !== 'avgPrice' &&
      item?.key !== '' &&
      item?.key !== 'priceBlister' &&
      !!item.value &&
      !!item.key
  }

  public trackByKey(index: number, item: { key: string }) {
    return item.key;
  }
}
